import React from 'react'
import { useTranslation } from 'react-i18next'
import { useFetchConsignmentSummary } from '../api/fetchConsignmentSummary'

function ConsignmentSummary({ consignmentId } : Readonly<{ consignmentId: number | null }>) {
  const { t } = useTranslation()
  const { data: summary } = useFetchConsignmentSummary(consignmentId)

  return (
    <div className="consignment-summary user-select-none">
      <span className="consignment-summary__item">
        <span className="consignment-summary__label">{t('declaration.p5.totalNumberOfPackages')}</span>
        <span className="consignment-summary__value">{summary?.numberOfPackages ?? 0}</span>
      </span>
      <span className="consignment-summary__item">
        <span className="consignment-summary__label">{t('declaration.p5.grossWeight', { context: 'current' })}</span>
        <span className="consignment-summary__value">{summary?.totalGrossWeight.toFixed(3) ?? 0}</span>
      </span>
    </div>
  )
}

export default ConsignmentSummary
